import React, { SVGProps } from 'react'

const GBPUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_2023_9837)'>
      <path d='M0 0H48V48H0V0Z' fill='white' />
      <path
        d='M18.6667 0H2.66667L18.6667 14.6667V0ZM29.3333 0V16L46.6667 0H29.3333ZM48 12L40 18.6667H48V12ZM48 29.3333H37.3333L48 38.6667V29.3333ZM45.3333 48L29.3333 33.3333V48H45.3333ZM18.6667 48V32L1.33333 48H18.6667ZM0 36L8 29.3333H0V36ZM0 18.6667H10.6667L0 9.33333V18.6667Z'
        fill='#0D47A1'
      />
      <path
        d='M18.6667 18.6666L-17.3333 -13.3334V-7.20004L13.3333 18.6666H18.6667ZM21.3333 21.3333V-4.19617e-05H26.6667V21.3333H48V26.6666H26.6667V48H21.3333V26.6666H0V21.3333H21.3333ZM-24 61.3333L13.3333 29.3333H18.6667L-17.3333 61.3333H-24ZM29.3333 18.6666L61.3333 -10.6667H67.2L34.6667 18.6666H29.3333ZM34.6667 29.3333H29.3333L60 56V50.6666L34.6667 29.3333Z'
        fill='#EF5350'
      />
    </g>
    <defs>
      <clipPath id='clip0_2023_9837'>
        <rect width='48' height='48' rx='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default GBPUSD
